export default __webpack_public_path__ + "static/media/1t.1c3e9e68.jpg";